import React from 'react';
import { Box, Slider, SliderProps } from '@mui/material';

const mark = (line1: string, line2: string, align: 'left' | 'center' | 'right') => (
  <Box component="span" sx={{ display: 'block', textAlign: align, lineHeight: 1.2 }}>
    {line1}
    <br />
    {line2}
  </Box>
);

const VOLUME_MARKS = [
  { value: 0.8, label: mark('Batch', '80%', 'left') },
  { value: 1.0, label: mark('Standard', '100%', 'center') },
  { value: 1.5, label: mark('Prototype', '150%', 'right') },
];

const VolumeFactorSlider: React.FC<Omit<SliderProps, 'min' | 'max' | 'step' | 'marks'>> = ({ sx, ...props }) => (
  <Box sx={{ px: 0.5, overflow: 'hidden' }}>
    <Slider
      min={0.8}
      max={1.5}
      step={null}
      marks={VOLUME_MARKS}
      {...props}
      sx={[
        {
          mt: 1.25,
          mb: 5,
          '& .MuiSlider-markLabel': {
            fontSize: 11,
            color: 'text.secondary',
            top: 26,
            whiteSpace: 'nowrap',
          },
          '& .MuiSlider-markLabel[data-index="0"]': {
            transform: 'translateX(0)',
          },
          '& .MuiSlider-markLabel[data-index="2"]': {
            transform: 'translateX(-100%)',
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  </Box>
);

export default VolumeFactorSlider;
